import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import './accordion.scss';

type AccordionProps = {
    children: React.ReactNode;
    title: React.ReactNode;
    name?: string;
};

const Accordion = ({
    children,
    title,
    name='accordion',
}: AccordionProps) => {

    const [isExpanded, setExpanded] = useState(false);

    const toggle = () => setExpanded(!isExpanded);

    const ref = useRef<HTMLDivElement | null>(null);

    const classes = classnames('b-accordion', {
        'is-expanded': isExpanded,
    });

    return (
        <div ref={ref} className={classes}>
            <p className="accordion-title" onClick={toggle} data-testId={name}>{title}<span className="arrow" /></p>
            <div className="expandable-content">
                <div className="inner-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Accordion;
